import { useCallback, useMemo, useState } from "react";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import { usePortFilter } from "../../hooks/PortFilter";
import usePortfolio from "../../hooks/PortfolioProvider";
import { usePath } from "../../libs/path/PathProvider";
import useDateRangeFilter, { DateRangeFilterProvider } from "../../portlibs/DateRangeFilterProvider";
import TransanctionsToolbar from "./TransactionsToolbar";
import { THoldingTypes, getHoldingType } from "../../shared/Consts";
import Utils from "../../libs/Utils";
import PortUtils from "../../portlibs/PortUtils";
import DialogTitle from "../widgets/DialogTitle";
import TransactionTable from "../widgets/TransactionTable";

const DIALOG_ID = "transactions"
const COLS : Record<THoldingTypes,string[]> = {
    cash:["date", "quantity", "type", "balance", "note"],
    equity:["date", "quantity", "price", "type", "note"],
    fixed:["date", "quantity", "yield", "maturity", "note"],
    save:["date", "quantity", "yield", "note"]
}

function TransactionsDlg(props:{holdingId:string}) {
    const cols = COLS[getHoldingType(props.holdingId)]
    const [search,setSearch] = useState<string>("")
    const {portfolio} = usePortfolio()
    const {account} = usePortFilter()
    const {start,end} = useDateRangeFilter()
    const holding = portfolio.holding(props.holdingId)!
    const transactions = useMemo(() => {
        var list = account>=0 ? holding.filterByAccount(account).transactions : holding.transactions
        list = search ? list.filter(trans => trans.filter(search)) : list
        list = list.filter(trans => trans.date>=start && trans.date<=end)
        return list
    }, [account, search, holding])
    const onExport = useCallback(() => Utils.exportFile(PortUtils.toCSV(transactions, cols), `Trans ${Utils.formatDate("yyyy-MM-dd", new Date())}.csv`), [transactions])
    return <>
        <DialogTitle title={holding.name} overlayId={DIALOG_ID}/>
        <TransanctionsToolbar search={search} onSearch={search=>setSearch(search)} onExport={onExport}/>
        <div className="flex1 content scroller">
            <TransactionTable holding={holding} tableName="transactions" cols={cols} rows={transactions}/>
        </div>
    </>
}
export default function useTransactionsDlg(){
    const {setHash} = usePath()
    const {addOverlay,hasOverlay} = useOverlay()
    const {portfolio} = usePortfolio()
    const afterClosed = () => setHash("")
    const showHistory = (id:string) => {
        const holding = portfolio.holding(id)
        if (hasOverlay(DIALOG_ID) || !holding) return
        addOverlay(DIALOG_ID, {
            children:<DateRangeFilterProvider><TransactionsDlg holdingId={id}/></DateRangeFilterProvider>,
            backdropClass:"fullscreen",
            className:"flex vert",
            afterClosed
        })
    }

    return {showHistory}
}